export function set_route_id(id) {
    return async dispatch => {
        try {
            await dispatch(sett_route_id(id))
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

export function clear_route_id() {
    return async dispatch => {
        try {
            await dispatch(route_id_cleared())
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

function sett_route_id(id) {
    return { type: 'SET_ROUTE_ID', id }
}

function route_id_cleared() {
    return { type: 'ROUTE_ID_CLEARED' }
}
